import React, { useEffect, useRef } from 'react';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const TooltipButton = ({ tooltipTitle, tooltipContent, children }) => {
    const triggerRef = useRef(null);

    useEffect(() => {
        if (!triggerRef.current || !tooltipContent) return undefined;

        const tooltipInstance = new Tooltip(triggerRef.current, {
            title: tooltipContent,
            trigger: 'hover',
            html: true,
            customClass: 'tooltip-success',
        });

        // Cleanup tooltip when the component unmounts
        return () => {
            tooltipInstance.dispose();
        };
    }, [tooltipContent]); // Include tooltipContent in the dependency array

    return (
        <div>
            <span
                ref={triggerRef}
                className="tooltip-button text-success-600"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
            >
                {children}
            </span>
            <div className="my-tooltip tip-content hidden text-start shadow">
                <h6 className="text-white">{tooltipTitle}</h6>
                <p className="text-white">{tooltipContent}</p>
            </div>
        </div>
    );
};

export default TooltipButton;
